<template>
  <pure-quiz-screen :quiz="quiz" />
</template>

<script>
import PureQuizScreen from '@/views/PureQuizScreen'

export default {
  name: 'quiz-screen',
  components: { PureQuizScreen },
  props: {
    showtextpane: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    quiz() {
      return {
        showtextpane: this.$props.showtextpane,
        questionlist: {
          questions: this.$store.getters.getQuestionFlow
        },
        textpane: this.getTextpaneContent()
      }
    }
  },
  methods: {
    getTextpaneContent() {
      let questions = this.$store.getters.getQuestionFlow
      let currentId = null
      questions.forEach(question => {
        currentId = question.id
      })
      return this.$store.getters.getTextpaneById(currentId).html
    }
  }
}
</script>
